import _objectWithoutProperties from '../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import React from 'react';
import Icon from '../components/Icon/Icon.js';

var IconDataProtection = function IconDataProtection(_ref) {
  var title = _ref.title,
      filled = _ref.filled,
      otherProps = _objectWithoutProperties(_ref, ["title", "filled"]);

  return /*#__PURE__*/React.createElement(Icon, otherProps, filled ? /*#__PURE__*/React.createElement("svg", {
    title: title,
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 6h30a3.01 3.01 0 012.995 2.824L36 9v3.007a6.01 6.01 0 015.996 5.775l.004.225V21h3a3.01 3.01 0 012.995 2.824L48 24v15a3.01 3.01 0 01-2.824 2.995L45 42H27a3.01 3.01 0 01-2.995-2.824L24 39v-3H3a3.01 3.01 0 01-2.995-2.824L0 33V9a3.01 3.01 0 012.824-2.995L3 6zm33 21a2.25 2.25 0 00-2.25 2.25c0 .597.237 1.135.618 1.537l.132.13V34.5a1.5 1.5 0 002.993.144l.007-.144v-3.584c.457-.412.75-1.002.75-1.666A2.25 2.25 0 0036 27zm-6-9H3v15h21v-9a3.01 3.01 0 012.824-2.995L27 21h3v-3zm5.973-3a3.02 3.02 0 00-2.938 2.316L33 17.49V21h6v-2.993C39 16.35 37.643 15 35.974 15zM14 10.5a1.5 1.5 0 100 3 1.5 1.5 0 100-3zm-4 0a1.5 1.5 0 100 3 1.5 1.5 0 100-3zm-4 0a1.5 1.5 0 100 3 1.5 1.5 0 100-3z"
  })) : /*#__PURE__*/React.createElement("svg", {
    title: title,
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 6h30a3.01 3.01 0 012.995 2.824L36 9v3.007a6.01 6.01 0 015.996 5.775l.004.225V21h3a3.01 3.01 0 012.995 2.824L48 24v15a3.01 3.01 0 01-2.824 2.995L45 42H27a3.01 3.01 0 01-2.995-2.824L24 39v-3H3a3.01 3.01 0 01-2.995-2.824L0 33V9a3.01 3.01 0 012.824-2.995L3 6zm42 18H27v15h18V24zm-9 3a2.25 2.25 0 012.25 2.25c0 .597-.237 1.135-.618 1.537l-.132.13V34.5a1.5 1.5 0 01-2.993.144L34.5 34.5v-3.584a2.236 2.236 0 01-.75-1.666A2.25 2.25 0 0136 27zm-6-9H3v15h21v-9a3.01 3.01 0 012.824-2.995L27 21h3v-3zm6-3a3.007 3.007 0 00-2.995 2.83l-.005.176V21h6v-2.993A3.008 3.008 0 0036 15zm-3-6H3v6h27.816a6.035 6.035 0 011.917-2.017L33 12.82V9zM6 10.5a1.5 1.5 0 110 3 1.5 1.5 0 110-3zm4 0a1.5 1.5 0 110 3 1.5 1.5 0 110-3zm4 0a1.5 1.5 0 110 3 1.5 1.5 0 110-3z"
  })));
};

export default IconDataProtection;
